var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input-password',_vm._g(_vm._b({staticClass:"ui-input-password",attrs:{"size":"large"}},'a-input-password',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }